import Vue from 'vue'
import Vuex from 'vuex'
import api from "@/api/index.js";

Vue.use(Vuex)

var store = new Vuex.Store({
  state: {
    articleList: [],
    totalArticleNum: 0,
    categoryList: [],
    categoryArticleNumList: [],
    linksList: [],
    totalLinksNum: 0,
    currentArticlePath: "",
    currentArticleIcon: "",
    markdownData: "",
    searchInputString: "",
    activeIndex: "/home",
    currentHomePage: 1,
  },
  mutations: {
    //==========友链接口==========
    queryAllLinks(state) {
      api.QueryAllLinks((response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          state.linksList = result.data;
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    addLinks(state, param) {
      api.AddLinks({
        websiteName: param.websiteName,
        email: param.email,
        websiteLink: param.websiteLink,
        remarks: param.remarks,
      }, (response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          param.cb();
          this._vm.$message.success(response.data.msg);
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    //==========分类接口==========
    queryCategoryInfoList(state) {
      api.QueryCategoryInfoList((response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          state.categoryList = result.data;
          store.commit("queryArticleCount");
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    //=================文章接口=================
    queryArticleCount(state) {
      var categoryIdList = state.categoryList.map((category) => { return category.id }).join(',');
      api.QueryArticleCount(categoryIdList, (response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          state.categoryArticleNumList = result.data;
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    queryArticleList(state, param) {
      api.QueryArticleList(param, (response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          state.currentHomePage = param.page;
          state.totalArticleNum = result.totalNumber;
          state.articleList = result.data;
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    queryArticleContent(state, param) {
      api.QueryArticleContent(param.id, (response) => {
        console.log(response.data);
        var result = response.data;
        if (result.code == 200) {
          param.cb(result.data);
        } else {
          this._vm.$message.error(response.data.msg);
        }
      });
    },
    setSearchInputString(state, param) {
      state.searchInputString = param;
    },
    setActiveIndex(state, param) {
      state.activeIndex = param;
    }
  },
  actions: {
  },
  modules: {
  }
})

export default store